const { isTransientNetworkError } = require('./riotRequestRecovery');

function renewalCode(error) {
    return error && (error.code || error.message) || '';
}

function riotAuthorizationFailureCode(data) {
    if (!data || typeof data !== 'object') return '';
    if (data.type === 'auth') return 'RIOT_COOKIE_EXPIRED';
    if (data.type === 'multifactor') return 'RIOT_LOGIN_INTERACTION_REQUIRED';
    const code = String(data.errorCode || data.error || '').toUpperCase();
    return ['AUTH_FAILURE', 'AUTHENTICATION_FAILED', 'UNAUTHORIZED', 'INVALID_SESSION', 'SESSION_EXPIRED'].includes(code)
        ? 'RIOT_COOKIE_EXPIRED' : '';
}

function isRiotRenewalTemporaryFailure(error) {
    const code = renewalCode(error);
    if (isTransientNetworkError(error)) return true;
    return ['RIOT_RENEW_TIMEOUT', 'RIOT_VSHOP_RENEW_TIMEOUT',
        'RIOT_VSHOP_ENTITLEMENTS_TIMEOUT', 'RIOT_VSHOP_USERINFO_TIMEOUT',
        'RIOT_RENEW_UNAVAILABLE', 'RIOT_VSHOP_RENEW_UNAVAILABLE',
        'RIOT_AUTHORIZATION_INVALID', 'RIOT_RESPONSE_INVALID',
        'RIOT_ENTITLEMENTS_INVALID', 'RIOT_USERINFO_INVALID'].includes(code);
}

function isRiotRenewalLoginRequired(error) {
    return ['RIOT_COOKIE_EXPIRED', 'RIOT_COOKIE_NOT_FOUND', 'RIOT_SESSION_NOT_READY', 'RIOT_SESSION_EXPIRED',
        'RIOT_LOGIN_INTERACTION_REQUIRED', 'RIOT_VSHOP_LOGIN_REQUIRED'].includes(renewalCode(error));
}

async function retryRiotAuthorization(authorize, check) {
    for (let index = 0; index < 2; index++) {
        check();
        try {
            const result = await authorize(index);
            check();
            return result;
        } catch (error) {
            check();
            const status = Number(error && error.httpStatus) || 0;
            const retryable = isTransientNetworkError(error)
                || [502, 503, 504].includes(status)
                || ['RIOT_RENEW_TIMEOUT', 'RIOT_VSHOP_RENEW_TIMEOUT'].includes(renewalCode(error))
                || (renewalCode(error) === 'RIOT_AUTHORIZATION_INVALID' && (!status || status === 200));
            if (index || !retryable) throw error;
        }
    }
}

module.exports = { isRiotRenewalTemporaryFailure, isRiotRenewalLoginRequired, retryRiotAuthorization, riotAuthorizationFailureCode };
